// @flow

import { createValidator, required, maxLength } from 'gandi.react-form';

import type { AccountFormProps } from './AccountForm';

const MAXLENGTH_VALUE = 15;

function mustBeTrue(
  value: boolean | string | void,
  data: any,
  props: AccountFormProps,
): void | string {
  if (value !== true) {
    return props.translator.__('You must accept this agreement');
  }

  return undefined;
}

type Value = {
  type?: any,
  name?: any,
  orgname?: any,
};
export default (value: Value, props: AccountFormProps): any => {
  let validation = {
    firstname: required,
    lastname: required,
    streetaddr: required,
    city: required,
    country: required,
    email: required,
    phone: required,
    currency: required,
    siren: maxLength(MAXLENGTH_VALUE),
  };

  if ('type' in value) {
    validation = { ...validation, type: required };
  }

  if ('name' in value) {
    validation = { ...validation, name: required };
  }

  if ('orgname' in value) {
    validation = { ...validation, orgname: required };
  }

  // $FlowFixMe[prop-missing]
  if (props.isMandatorySubdivision) {
    validation = { ...validation, state: required };
  }

  if (Array.isArray(props.contracts)) {
    const contracts = props.contracts.reduce(
      (old, current, index) => ({ ...old, [`contract${index}`]: mustBeTrue }),
      {},
    );
    // $FlowFixMe[cannot-spread-indexer] TODO: Fix type
    validation = { ...validation, ...contracts };
  }

  return createValidator(validation)(value, props);
};
